import {IEmployeePreview} from "api/types";
import {Dispatch, MutableRefObject, SetStateAction, createContext} from "react";

export interface IEmployeesContext {
  loading: boolean;
  employees?: IEmployeePreview[];
  page: number;
  pages: number;
  setPage: Dispatch<SetStateAction<number>>;
  scroll: MutableRefObject<number>;
  total?: number;
}

const EmployeesContext = createContext<IEmployeesContext>({} as IEmployeesContext);

export default EmployeesContext;
